import { render, staticRenderFns } from "./supplierStream.vue?vue&type=template&id=55bbaa5a&scoped=true&"
import script from "./supplierStream.vue?vue&type=script&lang=js&"
export * from "./supplierStream.vue?vue&type=script&lang=js&"
import style0 from "./supplierStream.vue?vue&type=style&index=0&id=55bbaa5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bbaa5a",
  null
  
)

export default component.exports